import {EventEmitterConfig} from "./eventEmitterConfig";

type EventCallback = (detail: any) => void;

/**
 * EventEmitter для работы с пользовательскими событиями через window
 *
 * @method  on  -
 *      * Подписка на пользовательское событие.
 *      * @param event - Название события без префикса.
 *      * @param callback - Обработчик события.
 * @method  emit  -
 *      * Отправка пользовательского события.
 *      * @param event - Название события без префикса.
 *      * @param detail - Данные, передаваемые в событии.
 * @returns {} - 
 */

export class EventEmitter  {
    private constructor() {}
    /**
     * Подписка на пользовательское событие.
     * @param event - Название события без префикса.
     * @param callback - Обработчик события.
     */
   static on(event: string, callback: EventCallback) {
        const fullName = EventEmitterConfig.splitByPrefix(event);
        const handler = (e: Event) => {
            const customEvent = e as CustomEvent;
            callback(customEvent.detail);
        };
        window.addEventListener(fullName, handler);
        return () => window.removeEventListener(fullName, handler); // возможность отписки
    }

    /**
     * Отправка пользовательского события.
     * @param event - Название события без префикса.
     * @param detail - Данные, передаваемые в событии.
     */
   static emit(event: string, detail?: any) {
        const fullName = EventEmitterConfig.splitByPrefix(event);
        const customEvent = new CustomEvent(fullName, { detail });
        window.dispatchEvent(customEvent);
    }
};